/**
 * Get page slugs from locale
 * @param {Object} translations - Translations object from locale
 * @returns {Object} Object with all page slugs
 */
export const getPageSlugs = (translations) => {
  return translations?.pages?.slugs || {}
}

/**
 * Get specific page slug
 * @param {Object} translations - Translations object from locale
 * @param {string} key - Slug key (e.g., 'globalHub', 'apps')
 * @returns {string} Page slug
 */
export const getPageSlug = (translations, key) => {
  return translations?.pages?.slugs?.[key] || ''
}

/**
 * Get all segment page slugs with their types
 * @param {Object} translations - Translations object from locale
 * @returns {Array} Array of {slug, type, localeKey} objects
 */
export const getSegmentPageSlugs = (translations) => {
  const slugs = getPageSlugs(translations)
  // Map to actual slug keys that exist in pages.slugs
  return [
    { slug: slugs.rankings, type: 'ranking', localeKey: 'pages.slugs.rankings' },
    { slug: slugs.comparisons, type: 'comparison', localeKey: 'pages.slugs.comparisons' },
    { slug: slugs.speed, type: 'hookups', localeKey: 'pages.slugs.speed' },
    { slug: slugs.edgy, type: 'adult', localeKey: 'pages.slugs.edgy' },
    { slug: slugs.beginner, type: 'advice', localeKey: 'pages.slugs.beginner' },
    { slug: slugs.safety, type: 'tips', localeKey: 'pages.slugs.safety' }
  ].filter(page => page.slug) // Only include pages that have slugs
}

/**
 * Get global hub slug
 * @param {Object} translations - Translations object from locale
 * @returns {string} Global hub slug
 */
export const getGlobalHubSlug = (translations) => {
  return getPageSlug(translations, 'globalHub')
}

